import { get, post, del } from './client.js';

export const list = (orgId) => get(`/orgs/${orgId}/templates`);
export const create = (orgId, body) => post(`/orgs/${orgId}/templates`, body);
export const remove = (orgId, id) => del(`/orgs/${orgId}/templates/${id}`);
export const apply = (orgId, id) => post(`/orgs/${orgId}/templates/${id}/apply`, {});
export const clone = (orgId, id, body) => post(`/orgs/${orgId}/templates/${id}/clone`, body);
